import theme from '@vromo/ui/components/theme';

export default {
    container: {
        flex: 1,
        overflow: 'auto'
    },
    numberInput: {
        textAlign: 'center'
    },
    tableContainer: {
        width: '100%',
        overflow: 'auto',
        marginTop: '15px',
        position: 'relative'
    },
    ratesWrapper: {
        marginBottom: 16
    },
    infoTitle: {
        textAlign: 'center',
        whiteSpace: 'nowrap'
    },
    infoIconContainer: {
        display: 'inline-block',
        marginLeft: 10
    },
    applyFiltersButton: {
        marginLeft: 20,
        marginBottom: 40
    },
    exportCSVButton: {
        height: 36
    },
    exportIcon: {
        marginLeft: 8
    },
    loadingContainer: {
        display: 'flex',
        width: '100%',
        height: 80,
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.mediumGrey
    }
};
